import { render, staticRenderFns } from "./withdrawRengong.vue?vue&type=template&id=bb20e450&scoped=true&"
import script from "./withdrawRengong.vue?vue&type=script&lang=js&"
export * from "./withdrawRengong.vue?vue&type=script&lang=js&"
import style0 from "./withdrawRengong.vue?vue&type=style&index=0&id=bb20e450&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20e450",
  null
  
)

export default component.exports